import SuccessBaseScreen from './SuccessBaseScreen';

export default SuccessBaseScreen;
